import React, {useEffect, useState} from 'react';
import {Mention, MentionsInput} from "react-mentions";
import {useStores} from "../../../stores/Context";
import {useParams} from "react-router-dom";

const MIMessimage = ({configurable}) => {
    const {ent} = useParams();
    const [totemList, setTotemList] = useState([]);
    const {widgetStore, messageInterServicesStore} = useStores();

    useEffect(() => {
        messageInterServicesStore.getAllTotem(ent).then((res) => {
            setTotemList(res);
        })
    },[]);

    return (
        <div className="MIMessimage">
            <MentionsInput
                disabled={true}
                className={'border-0 p-0 mb-2 mx-0'}
                value={configurable.contenu}
                style={{
                    width: '95%',
                    control: {
                        backgroundColor: '#fff',
                        fontSize: 16,
                    },

                    '&multiLine': {
                        control: {
                            minHeight: 60,
                        },
                        highlighter: {
                            padding: 9,
                            border: '1px solid transparent',
                        },
                        input: {
                            padding: 9,
                            border: '1px solid transparent',
                        },
                    },

                    '&singleLine': {
                        display: 'inline-block',
                        width: 280,

                        highlighter: {
                            padding: 1,
                            border: '2px inset transparent',
                        },
                        input: {
                            padding: 1,
                            border: '2px inset',
                        },
                    },

                    suggestions: {
                        list: {
                            backgroundColor: 'white',
                            border: '1px solid rgba(0,0,0,0.15)',
                            fontSize: 16,
                        },
                        item: {
                            padding: '5px 15px',
                            borderBottom: '1px solid rgba(0,0,0,0.15)',
                            '&focused': {
                                backgroundColor: '#cee4e5',
                            },
                        },
                    },
                }}
            >
                <Mention
                    className="bg-blue-200 rounded-lg py-0.5"
                    trigger="@"
                    style={{textDecoration: "underline #7148D7FF"}}
                    data={totemList.map(totem => ({id: totem.id_totem, display: totem.tot_nom}))}
                    renderSuggestion={(suggestion, search, highlightedDisplay, index, focused) => (
                        <div className={`user ${focused ? 'focused' : ''}`}>
                            {highlightedDisplay}
                        </div>
                    )}
                />
            </MentionsInput>
            { configurable.messimage !== ' ' && (
                <img src={`${process.env.REACT_APP_API_URL + "/" + configurable.messimage}`} alt="Selected"
                     className={'rounded-t-xl mb-0'}
                     style={{width: '100%', height: 'auto'}}/>
            )}
        </div>
    );
};

export default MIMessimage;